import {
  type DemandeStore,
  type PrintAction,
  buildPrintDemandeWithTemplate,
  useDemandePrint,
} from '@/features/interface/demande/shared'

export function useDemandePROAPrint(store: DemandeStore<'MODEL_PROA'>) {
  const actionPrintCerfa: PrintAction = {
    mustSave: true,
    label: 'Générer le CERFA',
    jobs: buildPrintDemandeWithTemplate<'MODEL_PROA'>({
        store,
        typeDocumentTemplate: 'Cerfa',
        filenameKeys: ['dispositif', 'id'],
    }),
  }

  return useDemandePrint<'MODEL_PROA'>({
    store,
    getActions: () => [actionPrintCerfa],
  })
}
